import { useCallback } from 'react'

import { isObjectEmpty } from 'commons/utils/object'
import type { ActionPerm, ScreenPerm } from 'components/Structures/Header/constants'
import { useSelector } from 'store/store'

export const useAuth = () => {
  const { token } = useSelector((state) => state.auth)

  const isAuthenticated = useCallback(() => {
    const getToken = JSON.parse(localStorage.getItem('token') || '{}')

    const hasValidToken = !isObjectEmpty(getToken) && getToken.authenticated

    return hasValidToken
  }, [token])

  return {
    isAuthenticated,
  }
}

export const useUserName = () => {
  const { cd_usua } = useSelector((state) => state.auth)

  return cd_usua
}
export const usePermissions = () => {
  const { permission } = useSelector((state) => state.auth)
  const PERMISSIONS = Object.values(permission)
  const verifyPermission = (screen: ScreenPerm | ScreenPerm[], action?: ActionPerm) => {
    if (PERMISSIONS) {
      if (Array.isArray(screen)) {
        if (action) {
          return PERMISSIONS?.some(
            (perm) => screen.includes(perm.Screen as ScreenPerm) && perm.Action === action,
          )
        } else {
          return PERMISSIONS?.some((perm) => screen.includes(perm.Screen as ScreenPerm))
        }
      } else {
        if (action) {
          return PERMISSIONS?.some((perm) => perm.Screen === screen && perm.Action === action)
        } else {
          return PERMISSIONS?.some((perm) => perm.Screen === screen)
        }
      }
    } else {
      return true
    }
  }
  return { PERMISSIONS, verifyPermission }
}
